import { html } from 'lit';

export const iconChevronLink = html`
  <svg
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.625 12.875C1.37891 12.875 1.16016 12.793 0.996094 12.6289C0.640625 12.3008 0.640625 11.7266 0.996094 11.3984L5.61719 6.75L0.996094 2.12891C0.640625 1.80078 0.640625 1.22656 0.996094 0.898438C1.32422 0.542969 1.89844 0.542969 2.22656 0.898438L7.47656 6.14844C7.83203 6.47656 7.83203 7.05078 7.47656 7.37891L2.22656 12.6289C2.0625 12.793 1.84375 12.875 1.625 12.875Z"
    />
  </svg>
`;
